import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import ChatService from '../../services/ChatService';
import Moment from 'react-moment';
import DataTable from '../DataTable';
import useApi from '../../api/useApi';
import useAuth from '../../context/useAuth';
import useQueryParams from '../../context/useQueryParams';
import { NumericFormat } from 'react-number-format';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const AuctioneerLots = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const [lotSummary, setLotSummary] = useState({});
    const lotSummaryRef = React.useRef(lotSummary);
    const [lotDetailsData, setLotDetailsData] = useState([]);
    const api = useApi();
    const { auth } = useAuth();
    const { setParameters } = useQueryParams();
    const [role] = useState(auth?.role?.toLowerCase());
    const gridApi = React.useRef(null);
    const [traderwiseReport, setTraderwiseReport] = useState([]);
    const [lotwiseReport, setLotwiseReport] = useState([]);
    const [lotwiseModalVisible, setLotwiseModalVisible] = useState(false);
    const [traderwiseModalVisible, setTraderwiseModalVisible] = useState(false);
    const [lotwiseGridApi, setlotwiseGridApi] = useState(null);
    const [traderwiseGridApi, setTraderwiseGridApi] = useState(null);
    const scrollTop = useRef(0);

    const handleOnConnectionEstablished = useRef(() => {

    }).current;

    const handleOnMessageReceived = useRef((message) => {

        if (message) {
            switch (message.message) {
                case 'START_LOT':
                case 'LOT_SOLD':
                case 'LOT_WITHDRAWN':
                case 'LOT_RERUN':
                    {
                        fetchDataFromApi();
                        break;
                    }
                default:
            }
        }

    }).current;

    const _chatService = ChatService({ onConnectionEstablished: handleOnConnectionEstablished, messageReceived: handleOnMessageReceived });

    const handleCellValueChanged = (params) => {
        // Extract the updated data from the grid

        const updatedData = lotDetailsData.map((row) =>
            row.lotId === params.data.lotId ? { ...row, [params.colDef.field]: params.newValue } : row
        );

        // Update the state with the new data
        setLotDetailsData(updatedData);

        // You can also perform additional actions with the updated data
    };

    const totalValueRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        const buttonClicked = () => {
            alert(`${cellValue} medals won!`);
        };

        return (
            <span>
                <span>{cellValue}</span>
                <br></br>
                <button className="btn btn-sm ripple btn-outline-primary fs-11 mg-t-5" onClick={() => buttonClicked()}>Lot Detail</button>
            </span>
        );
    };

    const linkRenderer = (props) => {

        const planterOrDealer = (props.node.data.planterDealer === '1' ? "P" : (props.node.data.planterDealer === '2' ? "D" : props.node.data.planterDealer));
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value + ' (' + planterOrDealer + ')';

        return (
            <span>
                <span role="button" className="custom-link" onClick={() => viewLotDetails(props.data.auctionId, props.node.data.lotNumber)}>{cellValue}</span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };
    const statusRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span className="has-withdraw-btn">
                <span>{cellValue}
                    {/*SHRAVAN V2{props.node.data.status === 8 ?*/}
                    {/*    <div className="after-sold-withdraw-btn">*/}
                    {/*        <button className="btn ripple btn-outline-danger mg-l-10 btn-sm" type="button" >*/}
                    {/*            Withdraw*/}
                    {/*        </button>*/}
                    {/*    </div> : null}*/}
                </span>
            </span>
        );
    };

    const columns = [
        {
            headerName: 'Lot No.', field: 'lotNumber', cellClass: 'text-center', width: 60
        },
        {
            headerName: 'Name of the Grower (Planter / Dealer)',
            field: 'planterName', flex: 1, minWidth: 280, wrapText: true, autoHeight: true,
            cellRenderer: linkRenderer
        },
        { headerName: 'Quantity (Kg)', field: 'quantityKg', cellClass: 'text-center', width: 90 },
        { headerName: 'No. of Bags', field: 'bags', cellClass: 'text-center', width: 70 },
        { headerName: 'Litre Weight (gm)', field: 'litreWeightGms', cellClass: 'text-center', width: 120 },
        {
            headerName: 'Starting Price (₹)', cellClass: 'highlight-light text-center',
            field: 'auctionStartPriceRs', width: 90, editable: (params) => (lotSummary.auctionStatus !== 2 && params.data.status === 0)

        },
        {
            headerName: 'Reserve Price (₹)', cellClass: 'highlight-light2 text-center',
            field: 'reservedPrice', width: 90, editable: (params) => (lotSummary.auctionStatus !== 2 && params.data.status === 0)
        },
        { headerName: 'Status', field: 'statusName', cellClass: 'text-center', width: 160, cellRenderer: statusRenderer },
        { headerName: 'Final Price (₹)', field: 'finalPrice', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Buyer Name', field: 'buyerName', width: 300, autoHeight: true },
        { headerName: 'Buyer Mobile Number', field: 'buyerMobileNumber', cellClass: 'text-center', width: 130 },
        //{ headerName: ' ', field: row => <button cellclassName="btn ripple btn-outline-primary text-nowrap btn-sm btn-rounded mg-r-5" onClick={() => viewLotDetails(row.lotId)}> <i cellclassName="fe fe-edit-2"></i> Detail</button> },
    ];

    const gridOptions = {

        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            sortable: false,
        },
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.data.status === 8) {
                return 'bg-lot-completed';
            }
            else if (params.node.data.status === 6) {
                return 'bg-lot-withdrawn';
            }
            else if (params.node.data.status >= 1 && params.node.data.status <= 5) {
                return 'bg-lot-inprogress';
            }
            else if (params.node.data.status === 7) {
                return 'bg-lot-skip';
            }
        },
        columnDefs: columns,
    };

    const fetchDataFromApi = async () => {
        try {
            let lotData = await api.getAuctioneerLots(id);
            setLotDetailsData(lotData.lotDetail);
            lotData.lotDetail = null;
            setLotSummary(lotData);
            lotSummaryRef.current = lotData;

        } catch (error) {
            alert('Unable to fetch lot detail data.');
        }
    };

    useEffect(() => {
        fetchDataFromApi();
    }, []);


    const getRowStyle = params => {
        //if (params.node.rowIndex % 2 === 0) {
        return { background: '#fff' };
        //}
    };

    const viewLotDetails = (auctionId, lotNo) => {
        if (lotSummaryRef.current.auctionStatus !== 2) {
            setParameters(prev => ({ ...prev, initialJumpToLotNo: lotNo }));
            //setParameters({ initialJumpToLotNo : lotNo })
            navigate(`/auctioneerLotDetails/${auctionId}`);
        }
        else
            alert("Action not allowed. This auction is already closed.");
    };

    const onCellEditingStarted = (event) => {
        if (lotSummary.auctionStatus === 2) {
            const api = gridApi.current;
            if (api) {
                api.stopEditing(true);
            }
        }
    };

    const saveLotDetail = async () => {
        const lotPriceData = lotDetailsData.map(t => {
            return {
                lotId: t.lotId,
                auctionId: t.auctionId,
                auctionStartPriceRs: t.auctionStartPriceRs,
                reservedPrice: t.reservedPrice,
            }
        })

        await api.saveLotPrice(lotPriceData)
            .then((response) => {
                fetchDataFromApi();
                alert("Record updated successfully");
            })
            .catch((error) => {
                // Handle error
                console.error('Error saving lot price data:', error);
            });
    };

    const closeAuction = async () => {

        if (window.confirm('Are you sure you want to close this auction.') === true) {
            await api.closeAuction(lotSummary.auctionId)
                .then((response) => {
                    if (response.success) {
                        fetchDataFromApi();
                        alert("Auction closed successfully");
                        setTimeout(() => {
                            navigate(`/auctioneer`);
                        }, 500)
                    }
                    else
                        alert(response.message);
                })
                .catch((error) => {
                    console.error('Error closing auction :', error);
                });
        }
    };

    const closeLotwiseModal = () => {
        setLotwiseModalVisible(false);
    }

    const closeTraderwiseModal = () => {
        setTraderwiseModalVisible(false);
    }

    const onLotwiseGridReady = (params) => {
        setlotwiseGridApi(params.api);
    };

    const onTraderwiseGridReady = (params) => {
        setTraderwiseGridApi(params.api);
    };

    const viewTraderwiseReport = async () => {
        const params = {
            AuctionId: parseInt(id),
        }
        await api.getReport('Traderwise', params).then((data) => {
            setTraderwiseReport(data);

            setTraderwiseModalVisible(true);
        })
    }
    const viewLotwiseReport = async () => {
        const params = {
            AuctionId: parseInt(id)
        }
        await api.getReport('Lotwise', params).then((data) => {
            setLotwiseReport(data);

            setLotwiseModalVisible(true);
        })
    }


    const lotwiseReportColumns = [
        { headerName: 'Lot No.', field: 'LotNumber', cellClass: 'text-center', width: 40 },
        { headerName: 'Quantity (Kg)', field: 'QuantityKg', cellClass: 'text-center', width: 80 },
        { headerName: 'Reserve Price', field: 'ReservedPrice', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Highest Price', field: 'HighestPrice', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Trade Value', field: 'TradeValue', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Name of Grower (Planter/Dealer)', wrapText: true, autoHeight: true, field: 'PlanterName', width: 260 },
        { headerName: 'Buyer Name', field: 'BuyerName', wrapText: true, autoHeight: true, cellClass: 'text-center', width: 260 },
        { headerName: 'Buyer Mobile Number', field: 'BuyerMobileNumber', cellClass: 'text-center', width: 100 },
        { headerName: 'Buyer Location', field: 'BuyerLocation', cellClass: 'text-center', width: 110 },
        { headerName: 'Lot Status', field: 'LotStatus', cellClass: 'text-center', width: 100 },
    ];
    const traderwiseReportColumns = [
        { headerName: '#', field: 'SrNo', wrapText: true, autoHeight: true, cellClass: 'text-center', width: 40 },
        { headerName: 'Buyer Name', field: 'BuyerName', wrapText: true, autoHeight: true, width: 230 },
        { headerName: 'Buyer Mobile Number', field: 'BuyerMobileNumber', cellClass: 'text-center', width: 130 },
        { headerName: 'Buyer Location', field: 'BuyerLocation', cellClass: 'text-center', width: 110 },
        { headerName: 'Quantity (Kg)', field: 'QuantityKg', cellClass: 'text-center', width: 80 },
        { headerName: 'Trade Value', field: 'TradeValue', cellClass: 'text-center', width: 100, cellRenderer: amountRenderer },
        { headerName: 'Lot Numbers', field: 'LotNumbers', wrapText: true, autoHeight: true, cellClass: 'text-center', width: 200 },
    ];

    const exportTraderReport = async () => {

        try {
            const { fileName, fileData } = await api.downloadReport('AuctioneerTraderWise', parseInt(id));
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }

        //const params = {
        //    suppressQuotes: false,
        //    columnSeparator: ',',
        //};

        //const data = traderwiseGridApi.getDataAsCsv(params);

        //const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        //const fileName = 'Traderwise Report.csv';

        //const link = document.createElement('a');
        //if (link.download !== undefined) {
        //    const url = URL.createObjectURL(blob);
        //    link.setAttribute('href', url);
        //    link.setAttribute('download', fileName);
        //    document.body.appendChild(link);
        //    link.click();
        //    document.body.removeChild(link);
        //}
    };


    const exportLotwiseReport = async () => {

        try {
            const { fileName, fileData } = await api.downloadReport('AuctioneerLotWise', parseInt(id));
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }

        //const params = {
        //    suppressQuotes: false,
        //    columnSeparator: ',',
        //};

        //const data = lotwiseGridApi.getDataAsCsv(params);

        //const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        //const fileName = 'Lotwise Report.csv';

        //const link = document.createElement('a');
        //if (link.download !== undefined) {
        //    const url = URL.createObjectURL(blob);
        //    link.setAttribute('href', url);
        //    link.setAttribute('download', fileName);
        //    document.body.appendChild(link);
        //    link.click();
        //    document.body.removeChild(link);
        //}
    };

    return (
        <div>
            <div className="inner-body">
                <div className="row row-sm mg-t-10">

                    <div className="col-md-12">
                        <div className="card custom-card">
                            <div className="d-flex justify-content-around">
                                <div className="bg-primary d-flex justify-content-around flex-fill rounded-top-11 rounded-end-0 bd-r pd-4 align-items-center">
                                    <h6 className="mg-b-0">No. of Lots Sold</h6><h4 className="mg-b-0">{lotSummary.lotsSold}</h4>
                                </div>
                                <div className="bg-primary d-flex justify-content-around flex-fill bd-r pd-4  align-items-center">
                                    <h6 className="mg-b-0">No. of Lots Withdrawn</h6><h4 className="mg-b-0">{lotSummary.lotsWithdrawn}</h4>
                                </div>
                                <div className="bg-primary d-flex justify-content-around flex-fill rounded-top-11 rounded-start-0 pd-4  align-items-center">
                                    <h6 className="mg-b-0">Remaining Lots</h6><h4 className="mg-b-0">{lotSummary.lotsRemaining}</h4>
                                </div>
                            </div>
                            <div className="d-flex justify-content-around pd-t-10 pd-b-5">
                                <div className="pe-0 ps-0 border-end">
                                    <div className="card-body text-center pd-4">
                                        <h6 className="mb-0">Auction Min</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹ </span>{lotSummary?.auctionMin?.toFixed(2)}</h4>

                                    </div>
                                </div>
                                <div className="pe-0 ps-0 border-end">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Auction Max</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹ </span>{lotSummary?.auctionMax?.toFixed(2)}</h4>
                                    </div>
                                </div>
                                <div className="pe-0 ps-0 border-end">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Auction Avg</h6>
                                        <h4 className="mb-1 number-font">
                                            <span className="counter">₹ </span>{lotSummary?.auctionAvg?.toFixed(2)}</h4>
                                    </div>
                                </div>
                                <div className="pe-0 ps-0 border-end">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Grower Avg</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹ </span>{lotSummary?.growerAvg?.toFixed(2)}</h4>
                                    </div>
                                </div>
                                <div className="pe-0 ps-0">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Dealer Avg</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹ </span>{lotSummary?.dealerAvg?.toFixed(2)}</h4>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between">
                                    <div className="btn-list mg-b-5">
                                        <button className="btn btn-sm ripple btn-outline-primary fs-11" onClick={() => navigate('/auctioneer')}><i class="ti ti-arrow-left me-2"></i>Back</button>
                                        <button className="btn btn-sm ripple btn-info fs-11" onClick={viewTraderwiseReport}>Trader Wise Report</button>
                                        <button className="btn btn-sm ripple btn-info fs-11" onClick={viewLotwiseReport}>Lot Wise Report</button>
                                    </div>
                                    {(role === 'primary auctioneer') && (lotSummary.auctionStatus !== 2) ?
                                        <div className="btn-list mg-b-5">
                                            <button className="btn btn-sm ripple btn-outline-primary fs-11" onClick={saveLotDetail}>Submit</button>
                                            <button className="btn btn-sm ripple btn-outline-danger fs-11" onClick={closeAuction}>Close Auction</button>
                                        </div> : lotSummary.auctionStatus === 2 ? <div><span className="badge rounded-pill bg-dark">Auction closed</span></div> : null}
                                </div>
                                <div>



                                    <div
                                        style={{ height: 500 }}
                                        className={
                                            "ag-theme-alpine"
                                        }
                                    >

                                        <AgGridReact
                                            className="auctionLotsGrid"
                                            deltaRowDataMode={true}
                                            suppressScrollOnNewData={true}
                                            gridOptions={gridOptions}
                                            rowData={lotDetailsData}
                                            getRowStyle={getRowStyle}
                                            onGridReady={(params) => (gridApi.current = params)}
                                            onCellEditingStarted={onCellEditingStarted}
                                            onCellValueChanged={handleCellValueChanged}
                                        />


                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={lotwiseModalVisible} size='lg' onHide={closeLotwiseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Lot wise report
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pd-t-0">
                    <div
                        style={{ height: 450, marginTop: '10px' }}
                        className={
                            "ag-theme-alpine"
                        }
                    >
                        <AgGridReact
                            gridOptions={gridOptions}
                            onGridReady={onLotwiseGridReady}
                            columnDefs={lotwiseReportColumns}
                            rowData={lotwiseReport}
                            getRowStyle={getRowStyle}
                        />
                    </div>
                    <button className="btn ripple btn-outline-primary mg-t-10  pd-x-10 mg-r-5 btn-sm" type="button" onClick={exportLotwiseReport}>
                        <i class="ti ti-import me-2"></i>Export to excel
                    </button>
                </Modal.Body>
            </Modal>
            <Modal show={traderwiseModalVisible} size='lg' onHide={closeTraderwiseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Trader wise report </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pd-t-0">
                    <div
                        style={{ height: 450, marginTop: '10px' }}
                        className={
                            "ag-theme-alpine"
                        }
                    >
                        <AgGridReact
                            gridOptions={gridOptions}
                            onGridReady={onTraderwiseGridReady}
                            columnDefs={traderwiseReportColumns}
                            rowData={traderwiseReport}
                            getRowStyle={getRowStyle}
                        />
                    </div>
                    <button className="btn ripple btn-outline-primary pd-x-10 mg-t-10 mg-r-5 btn-sm" type="button" onClick={exportTraderReport}>
                        <i class="ti ti-import me-2"></i>Export to excel
                    </button>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default AuctioneerLots;